import React from 'react';

const BetItemBespokeMarketOutcome = ({ outcome, market }) => (
  <div className='event__outcome-container'>
    <span className='event__outcome-logo event__outcome-logo--empty' />
    <div className='event__outcome-details'>
      <div className='event__outcome-name'>{outcome.localizedName}</div>
      <div className='event__market-name'>
        <span className='event__market-name--name'>{market.localizedName}</span>
      </div>
    </div>
  </div>
);

export default BetItemBespokeMarketOutcome;
